export const Custom = {
  componentId: "Custom",
  resources: [],
};
